import { render, staticRenderFns } from "./TranscriptTextLayer.vue?vue&type=template&id=3b22b451&"
import script from "./TranscriptTextLayer.vue?vue&type=script&lang=js&"
export * from "./TranscriptTextLayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports